<template>
    <div class="nav">
        <a v-for="(nav,index) in navList" :key="index" :href="nav.link">
            <p>
                <img :src="nav.icon" alt="">
            </p>
            <p>{{nav.name}}</p>     
        </a>   
    </div>
</template>

<script>
import icon1 from '../../assets/images/snav_icon_1.png'
import icon2 from '../../assets/images/snav_icon_2.png'
import icon3 from '../../assets/images/snav_icon_3.png'
import icon4 from '../../assets/images/snav_icon_4.png'
import icon5 from '../../assets/images/snav_icon_5.png'
import icon6 from '../../assets/images/snav_icon_6.png'
import icon7 from '../../assets/images/snav_icon_7.png'
import icon8 from '../../assets/images/snav_icon_8.png'

export default{
    name: 'Nav',
    data(){
        return{
            navList:[
                {link: `#/course/${encodeURI('小学教育')}`, name: '小学教育', icon: icon1},
                {link: `#/course/${encodeURI('初中教育')}`, name: '初中教育', icon: icon2},
                {link: `#/course/${encodeURI('高中教育')}`, name: '高中教育', icon: icon3},
                {link: 'https://v.gxnews.com.cn/a/19253719', name: '课程表', icon: icon4},
                //{link: '#/weike', name: '名师助学', icon: icon5},
                //{link: `#/child/${encodeURI('少儿编程')}`, name: '少儿编程', icon: icon6},
                // {link: '#/course', name: '学校公告', icon: icon7},
                // {link: '#/course', name: '名师解惑', icon: icon8},
            ]    
        }
    },
    created(){
        
    },
    methods:{
        
    },
    components: {

    }
}
</script>

<style lang="less" scoped>
    .nav{
        padding-top: 0.3rem;
        margin-bottom: 0.3rem;
        background: #fff;
        overflow: hidden;
        border-bottom: 0.2rem solid #f3f3f3;
        a{
            display: block;
            float: left;
            width: 25%;
            text-align: center;
            color: #333;
            font-size: 0.38rem;
            margin-bottom: 0.3rem;
        }
        p{
            &:nth-of-type(1){
                margin-bottom: 0.1rem;
            }
        }
        img{
            width: 42%;
        }
    }          
</style>   